import React, { useEffect } from "react";
import "./Specialist.css";
import doctor from "../../../images/doctor.png";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
const Specialist = () => {
  useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 1500,
    });
  }, []);
  return (
    <div>
      <h2 className="title-design lg:pt-10 text-2xl lg:text-4xl font-extrabold">
        Our Specialist
      </h2>
      <div className="mt-12">
        <div className="banner-design pt-8 grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 justify-center ">
          <div data-aos="zoom-in-right" className="lg:pl-36">
            <img
              className="w-3/6 lg:w-4/6 mx-auto"
              src={doctor}
              alt="doctor"
              style={{ marginTop: 15 }}
            />
          </div>

          <div
            data-aos="zoom-in-left"
            className="items-center text-center p-5 lg:p-12 lg:pr-40"
          >
            <h2 className="text-2xl tracking-widest text-gray-700 pb-2 lg:pt-8 font-extrabold">
              We have Experience Doctor!
            </h2>
            <h1 className="text-3xl lg:text-6xl text-white font-bold lg:font-extrabold">
              Top Class Surgeon
            </h1>
            <hr />
            <p className="text-sm lg:text-xl pt-2 ">
              The surgeon establishes the diagnosis and provides the
              preoperative, operative, and postoperative care to patients and is
              often responsible for the comprehensive management of the trauma
              victim and the critically ill patient.
            </p>
            <Link to="/doctors">
              <button className="shadow rounded-lg text-white font-bold bg-green-600 p-2">
                Our Doctors
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Specialist;
